import { SxcApp } from '@2sic.com/sxc-angular';
import { httpResource } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MaintenanceData } from '../maintenance/maintenance.component';
import { RenewalFormValue } from '../maintenance/renewal/renewal.component';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceApiService {
  constructor(private app: SxcApp) {}

  getMaintenance() {
    return httpResource<MaintenanceData[]>(() => ({
      url: this.app.api('Maintenance').url('Get'),
      method: 'GET',
      body: {},
    })).value;
  }

  requestQuote(renewalFormValue: RenewalFormValue) {
    return this.app.api('Maintenance').post<RenewalFormValue>(
      'requestQuote',
      {}, // <- urlParams,
      renewalFormValue as unknown as RenewalFormValue, // Bug 2sxc Post Api Body and Request same Type
    );
  }
}
